import { defineComponent as _defineComponent } from 'vue'
import BCXItemsWithPoints from '@/components/molecules/BCXItemsWithPoints.vue';
import BCXButton from '@/components/molecules/BCXButton.vue';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicesActionButtons',
  props: {
  inBox: Boolean
},
  setup(__props) {

const { tUserFallback: t } = useUser('self');



return { __sfc: true,t, BCXItemsWithPoints, BCXButton }
}

})